export const CUE_TYPE_CUE = 'cue'
export const CUE_TYPE_HEADING = 'heading'
export const CUE_TYPE_GROUP = 'group'
